"use strict";
/// <reference path='../../app.typings.d.ts' />
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        'use strict';
        var ApDropDownDirective = /** @class */ (function () {
            function ApDropDownDirective() {
                this.restrict = 'E';
                this.templateUrl = 'app/components/ap-drop-down/ap-drop-down.html';
                this.scope = {
                    customListStyling: '=',
                    field: '@',
                    label: '@',
                    menuHeader: '@',
                    minLabelWidth: '@',
                    ngModel: '=',
                    preventSelection: '=',
                    selectCallback: '=',
                    selectionFormat: '=',
                    values: '=',
                    width: '@'
                };
                this.link = function (scope, element) {
                    setTimeout(function () {
                        if (scope.minLabelWidth) {
                            element.find('label').css('min-width', scope.minLabelWidth + 'px');
                        }
                    });
                    setTimeout(function () {
                        element.find('button').css('width', scope.width + 'px');
                        element.find('ul').css('width', scope.width + 'px');
                    });
                    scope.$watch('ngModel', function (newValue) {
                        if (!newValue) {
                            return;
                        }
                        if (scope.selectionFormat && scope.ngModel[scope.field]) {
                            scope.menuHeaderActive = scope.selectionFormat(scope.ngModel[scope.field]);
                        }
                        else {
                            scope.menuHeaderActive = scope.ngModel[scope.field] || scope.menuHeader;
                        }
                        scope.styleList();
                    }, true);
                    scope.$watch('label', function () {
                        if (!scope.label) {
                            return;
                        }
                        // wait for element names to be set before resizing.
                        setTimeout(function () {
                            var labelWidth = element.find('label').css('width');
                            var numberLabelWidth = labelWidth.replace('px', '');
                            var adjustedWidth = scope.width - +numberLabelWidth + 6;
                            element.find('button').css('width', adjustedWidth + 'px');
                            element.find('ul').css('width', scope.width + 'px');
                        }, 25);
                    });
                    if (scope.customListStyling) {
                        scope.$watch('values', function (newValue) {
                            if (!newValue) {
                                return;
                            }
                            scope.styleList();
                        }, true);
                    }
                    scope.checkIfSelectable = function (item) {
                        if (scope.preventSelection) {
                            return !scope.preventSelection(item);
                        }
                        return true;
                    };
                    scope.setSelectedItem = function (item) {
                        var selectable = scope.checkIfSelectable(item);
                        if (!selectable) {
                            return;
                        }
                        scope.ngModel[scope.field] = item;
                        scope.menuHeaderActive = scope.selectionFormat ? scope.selectionFormat(item) : item;
                        if (scope.selectCallback) {
                            scope.selectCallback(item);
                        }
                    };
                    scope.styleList = function () {
                        setTimeout(function () {
                            if (scope.customListStyling) {
                                var listElements = element.find('li');
                                angular.forEach(listElements, function (v, k) {
                                    scope.customListStyling(k, v, scope.$parent);
                                });
                            }
                        }, 0);
                    };
                };
            }
            ApDropDownDirective.factory = function () {
                var directive = function () {
                    return new ApDropDownDirective();
                };
                directive['$inject'] = [];
                return directive;
            };
            return ApDropDownDirective;
        }());
        angular.module('app')
            .directive('apDropDown', ApDropDownDirective.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
